import React from 'react'
import PageMaintenance from '../../pages/PageMaintenance'
import { eqxEvent } from '../../shared/classes/eqxEventBroker'
import generateContextProvider, { ContextProviderWrapperProps } from '../../shared/hooks/GenerateContextProvider'
import { useApiContext } from './AppApi'
import { useBaseConfigContext } from './AppBaseConfig'
import { useGlobalAppConfigContext } from './AppGlobalConfig'

interface AppMaintenanceHandler {
    showMaintenance: boolean
    maintenanceMessage: string
}

const AppMaintenanceHandlerWrapper = (props: ContextProviderWrapperProps<AppMaintenanceHandler>) => {
    const MaintenanceHandlerProvider = props.provider
    const api = useApiContext()
    const baseConfig = useBaseConfigContext()
    const globalCfg = useGlobalAppConfigContext()
    const [showMaintenance, setShowMaintenance] = React.useState<boolean>(false)
    const [maintenanceMessage, setMaintenanceMessage] = React.useState<string>('')

    React.useEffect(() => {
        const eventId = api.events.on('response426', function (this: eqxEvent, response: Response) {
            setShowMaintenance(true)
            setMaintenanceMessage('The application is currently undergoing maintenance. Please try again later.')
        })
        return () => {
            api.events.removeEvent('response426', eventId)
        }
    }, [])

    if (showMaintenance) {
        return (
            <PageMaintenance
                error={maintenanceMessage}
                frontendVersion={baseConfig.version}
                apiVersion={globalCfg.apiVersion}
                minApiVersion={globalCfg.minApiVersion}
            />
        )
    }

    return <MaintenanceHandlerProvider value={{ showMaintenance, maintenanceMessage }}>{props.children}</MaintenanceHandlerProvider>
}

const { ContextProvider: AppMaintenanceHandlerProvider, useContext: useMaintenanceHandlerContext } =
    generateContextProvider<AppMaintenanceHandler>(undefined, AppMaintenanceHandlerWrapper)

export { AppMaintenanceHandlerProvider as default, useMaintenanceHandlerContext, type AppMaintenanceHandler }

